import { NativeAudio } from '@capacitor-community/native-audio'
import { IAudioDriver } from './AudioService'

export class NativeDriver implements IAudioDriver {
  driver:   any

  constructor () {
    this.driver = NativeAudio
  }

  load(assetPath: string): void {
    this.driver.preload({ assetPath: 'public/' + assetPath, assetId: assetPath, isUrl: false })
  }

  play(assetId: string): void {
    return this.driver.play({ assetId })
  }

  pause(assetId: string): void {
    return this.driver.pause({ assetId })
  }

  stop(assetId: string): void {
    return this.driver.stop({ assetId })
  }
}